import React, { useState, useMemo } from 'react';
import { isPatreonExclusive, generatePatreonLink } from '../utils/patreonUtils';

/**
 * Component to generate Patreon-exclusive links for chapters
 * This is a utility component for admins to get shareable links
 */
function PatreonLinkGenerator({ chapters }) {
  const [copiedId, setCopiedId] = useState(null);

  const exclusiveChapters = useMemo(() => {
    return chapters.filter(chapter => isPatreonExclusive(chapter));
  }, [chapters]);

  const handleCopyLink = async (chapterId) => {
    const link = generatePatreonLink(chapterId);
    try {
      await navigator.clipboard.writeText(link);
      setCopiedId(chapterId);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
      alert(`Link: ${link}`);
    }
  };

  if (exclusiveChapters.length === 0) {
    return (
      <div className="main-content">
        <h1>Patreon Link Generator</h1>
        <p>No patreon-exclusive chapters found. Chapters become patreon-exclusive when their publish date is in the future.</p>
      </div>
    );
  }

  return (
    <div className="main-content">
      <h1>Patreon Link Generator</h1>
      <p style={{ marginBottom: '20px', color: '#676a6a' }}>
        Generate unique access links for Patreon supporters. These links bypass the public release date.
      </p>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        {exclusiveChapters.map(chapter => {
          const link = generatePatreonLink(chapter.id);
          const isCopied = copiedId === chapter.id;
          
          return (
            <div 
              key={chapter.id} 
              style={{ 
                padding: '15px', 
                border: '2px solid #acb0b1',
                borderRadius: '5px',
                backgroundColor: '#fff'
              }}
            >
              <h3 style={{ marginBottom: '10px', color: '#323232' }}>
                {chapter.title}
              </h3>
              <p style={{ marginBottom: '10px', color: '#676a6a', fontSize: '14px' }}>
                Publish Date: {chapter.date}
              </p>
              
              <div style={{ 
                display: 'flex', 
                gap: '10px', 
                alignItems: 'center',
                marginTop: '10px'
              }}>
                <input
                  type="text"
                  value={link}
                  readOnly
                  style={{
                    flex: 1,
                    padding: '8px',
                    border: '1px solid #acb0b1',
                    borderRadius: '3px',
                    fontFamily: 'monospace',
                    fontSize: '12px',
                    backgroundColor: '#f5f5f5'
                  }}
                  onClick={(e) => e.target.select()}
                />
                <button
                  onClick={() => handleCopyLink(chapter.id)}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: isCopied ? '#4CAF50' : '#f4b93b',
                    color: isCopied ? '#fff' : '#000',
                    border: 'none',
                    borderRadius: '3px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    transition: 'background-color 0.2s'
                  }}
                >
                  {isCopied ? '✓ Copied!' : 'Copy Link'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
      
      <div style={{ 
        marginTop: '30px', 
        padding: '15px', 
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '5px',
        color: '#856404'
      }}>
        <strong>Note:</strong> These links will work even before the chapter's public release date. 
        Share them only with Patreon supporters. The links remain valid permanently.
      </div>
    </div>
  );
}

export default PatreonLinkGenerator;

